import API from 'utils/api';

export default async () => {
  try {
    await API.options('catalogos/estados-globales/');
  } catch {
    // nada
  }
};
